
import { Component, Prop, Vue } from "vue-property-decorator";

import NBLogo from "@/assets/Logo-light.svg";
import NBIcon from "@/assets/Icon.svg";
import AppSidebarViewControl from "@/components/V2/AppSidebar/AppSidebarViewControl.vue";

const ICONS = {
  menuOutline: "menu-outline",
};

const CLASS = "sidebar-head";

@Component({
  components: {
    AppSidebarViewControl,
  },
})
export default class AppSidebarHead extends Vue {
  @Prop({ type: Boolean, default: false }) readonly collapsed!: boolean;

  icons = ICONS;

  get logoSrc() {
    return this.collapsed ? NBIcon : NBLogo;
  }

  get classes() {
    return {
      [`${CLASS}_collapsed`]: this.collapsed,
    };
  }

  toggle() {
    this.$emit("toggle");
  }

  toggleIfCollapsed() {
    if (this.collapsed) {
      this.toggle();
    } else {
      // this.$router.push(SMUser.basePath + "home");
    }
  }

  isHover = false;

  onHover() {
    this.isHover = true;
  }

  onLeave() {
    this.isHover = false;
  }

  get showLogo() {
    return !this.collapsed || (this.collapsed && !this.isHover);
  }

  get showControl() {
    return !this.collapsed || (this.collapsed && this.isHover);
  }
}
